type Environment = 'production' | 'staging' | 'development';

export function getSessionEnvironment(): Environment {
  let environment: Environment = 'development';
  const env = (globalThis as typeof globalThis & { process?: { env?: Record<string, string | undefined> } }).process
    ?.env?.ENVIRONMENT;
  if (env === 'production' || env === 'staging') {
    environment = env;
  }
  return environment;
}
